import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { JoiEvent } from 'globals/store/events.data';
import { LabelUpdateFunctionParams } from 'src/app/components/label-marker/label-maker.dialog.component';
import { environment } from '../../../../src/environments/environment';
import { ManageWrapperComponent, TabGroup } from '../manage/manage-wrapper.component';
import { Wrapper } from 'src/app/components/wrapper.component';
import { clipboardEditingPrivilegesReselector } from '../../store/reselectors/accounts.reselector';
import { ClipLabel } from 'globals/store/entity.data';
import { Asset, assetIconList, assetIconToName, assetTabs } from 'globals/store/assets.data';
import { generateEmailLink, getNumberFromText,  } from '../../helpers/helpers';
import { compactDate, jsonCopyObject, str2Date } from 'globals/helpers/helpers';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from '../../components/dialog.confirmDelete.component';
import { WFWorker } from 'globals/store/workforce.data';
import { Dictionary } from '@ngrx/entity';
import { entitiesReselector } from '../../store/reselectors/entity.reselector';
import { PeoplePickerComponent, PeoplePickerData } from '../../components/people-picker/people-picker.component';
import { OMEGA_GROUP_NAME } from 'globals/store/tasks.data';
import { openDialogGetResult } from '../../helpers/angular-helpers';
import { AllEntitySelectData, AllEntitySelectDialogComponent } from '../../components/entities/all-entity-select.dialog.component';
import { ItemStatus, StatusType } from 'globals/store/share.data';
import { ManageProgramData, Program, ProgramTabs, Session, SessionTabs } from 'globals/store/programs.data';
import { activitiesByAssetIdsReselector, attachedToCountByAssetIdReselector, eventInformationItemsByAssetIdsReselector, exhibitorInformationItemsByAssetIdsReselector, exhibitorStandsByAssetIdsReselector, performerInformationItemsByAssetIdsReselector, programsByAssetIdsReselector, resourceInformationItemsByAssetIdsReselector, runOfShowsByAssetIdsReselector, sessionsByAssetIdsReselector, sessionsByPresentationAssetIdsReselector, setupsByAssetIdsReselector } from '../../store/reselectors/assets.reselector';
import { ManageSessionComponent, ManageSessionData } from '../manage/manage-session.component';
import { InformableSectionItem } from 'globals/store/informables.data';
import { InformableDialogComponent, InformableEditInfo } from '../../components/informable/informable.dialog.component';
import { InformableType } from 'globals/store/informables.data';
import { ManageProgramComponent } from '../manage/manage-program.component';
import { ManageActivityData } from 'globals/store/onsite.data';
import { ManageActivityComponent } from '../manage/manage-activity.component';
import { IconDialogComponent, IconDialogData } from './icon.dialog.component';
import { ExhibitorStand } from 'globals/store/exhibitors.data';
import { ManageExhibitorStandData, ManageExhibitorStandDialogComponent } from '../exhibitors/manage-exhibitor-stand';
import { TypedEntity } from 'globals/store/entity.shared.data';
import { Label } from 'globals/store/events.data';
import { GreyWrapperComponent } from 'src/app/components/wrappers/grey-wrapper.component';
import { CommonModule } from '@angular/common';
import { EntityTasksComponent } from '../manage/entity-tasks.component';
import { UrlHandlerComponent } from 'src/app/components/file-handler/url-handler.component';
import { TitleIconComponent } from 'src/app/components/icon/title-icon.component';
import { JoiInputComponent } from 'src/app/components/joi-input/joi-input.component';
import { ShareCodeComponent } from '../share/share-code.component';
import { FakeDropdownComponent } from 'src/app/components/misc/fake-dropdown.component';
import { TitleToggleComponent } from 'src/app/components/wrappers/title-toggle-wrapper.component';
import { PrettyNumbersPipe } from 'src/app/services/pipes/prettyNumbers.pipe';
import { MenuHoverButtonComponent } from 'src/app/components/buttons/menu-hover-button.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { EntityTypesComponent } from 'src/app/components/entities/entity-types.component';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';

@Component({
    selector: 'manage-asset',
    templateUrl: './manage-asset.html',
    styleUrls: ['../manage/manage-dialogs.scss', '../manage/entity-drag.scss', './manage-assets.scss'],
    standalone: true,
    imports: [GreyWrapperComponent,  CommonModule, EntityTasksComponent, UrlHandlerComponent, TitleIconComponent, JoiInputComponent, ShareCodeComponent, FakeDropdownComponent, TitleToggleComponent, PrettyNumbersPipe, MenuHoverButtonComponent, MatDatepickerModule, MatFormFieldModule, MatInputModule, EntityTypesComponent, FormsModule, ManageWrapperComponent],
})
export class ManageAssetComponent extends Wrapper<ManageAssetComponent> implements OnInit {
  // exhibitorShareable: PublicEditProfileInfo
  assetBaseUrl = environment.joi.shareBase + 'exhibitor/';
  asset: Asset

  labels: Label[] = []
  labelMap: { [id:string]: Label } = {}
  generatingEditCode = false;
  tabs = assetTabs
  tabGroups: TabGroup[] = [{ tabs: [
    { id: assetTabs.details, name: 'Asset details' },
    { id: assetTabs.attached, name: 'Attached to' },
    { id: assetTabs.tasks, name: 'Tasks' },
  ]}]
  selectedTab
  clipLabel: ClipLabel
  event: JoiEvent
  readOnly: boolean
  today = new Date()
  workersByUId: { [key: string]: WFWorker } = {}
  workersByEmail: { [key: string]: WFWorker } = {}
  workforce: WFWorker[] = []
  entities: Dictionary<TypedEntity> = {}
  sessionsByAssetIds: Dictionary<Session[]>
  sessionsByPresentationAssetIds: Dictionary<Session[]>
  eventInformationItemsByAssetIds: Dictionary<InformableSectionItem[]>
  performerInformationItemsByAssetIds: Dictionary<InformableSectionItem[]>
  exhibitorInformationItemsByAssetIds: Dictionary<InformableSectionItem[]>
  resourceInformationItemsByAssetIds: Dictionary<InformableSectionItem[]>
  exhibitorStandsByAssetIds: Dictionary<ExhibitorStand[]>
  setupsByAssetIds: Dictionary<{ assetIds: string[], programId: string, name: string }[]>
  programsByAssetIds: Dictionary<Program[]>
  activityDataByAssetIds: Dictionary<ManageActivityData[]>
  attachedToCountByAssetId: Dictionary<number>
  runOfShowByAssetIds: Dictionary<any>
  iconNames = assetIconToName

  constructor(public changeDetectorRef: ChangeDetectorRef, public dialogRef: MatDialogRef<ManageAssetComponent>, @Inject(MAT_DIALOG_DATA) public data: ManageAssetData) {
    super()
    this.selectProp(sessionsByAssetIdsReselector, null, 'sessionsByAssetIds')
    this.selectProp(sessionsByPresentationAssetIdsReselector, null, 'sessionsByPresentationAssetIds')
    this.selectProp(eventInformationItemsByAssetIdsReselector, null, 'eventInformationItemsByAssetIds')
    this.selectProp(performerInformationItemsByAssetIdsReselector, null, 'performerInformationItemsByAssetIds')
    this.selectProp(exhibitorInformationItemsByAssetIdsReselector, null, 'exhibitorInformationItemsByAssetIds')
    this.selectProp(resourceInformationItemsByAssetIdsReselector, null, 'resourceInformationItemsByAssetIds')
    this.selectProp(exhibitorStandsByAssetIdsReselector, null, 'exhibitorStandsByAssetIds')
    this.selectProp(setupsByAssetIdsReselector, null, 'setupsByAssetIds')
    this.selectProp(programsByAssetIdsReselector, null, 'programsByAssetIds')
    this.selectProp(attachedToCountByAssetIdReselector, null, 'attachedToCountByAssetId')
    this.selectProp(runOfShowsByAssetIdsReselector, null, 'runOfShowByAssetIds')
    
    this.selectProp(activitiesByAssetIdsReselector, null, 'activityDataByAssetIds')
    this.selectCallback(clipboardEditingPrivilegesReselector, null, canClip => {
      if (canClip && !this.clipLabel) this.clipLabel = '+ ADD TO CLIPBOARD'
    })
    this.subProp(this.store.select('events', 'event'), 'event')
    this.subProp(this.store.select('assets','entities', data.assetId), 'asset')
    this.subCallback(this.store.select('workforce'), ({ workforce, workersByUId, workersByEmail }) => {
      // console.log({ workforce, workersByUId, workersByEmail })
      this.workersByUId = workersByUId
      this.workersByEmail = workersByEmail
      this.workforce = workforce
    })
    this.subProp(this.store.select(entitiesReselector), 'entities')
  }
  

  ngOnInit() {
    this.subCallback(this.store.select('events', 'labelMaps', 'asset_labels'), labels => {
      // console.log({ labels })
      this.labels = Object.values(labels)
      this.labelMap = labels
    })
    setTimeout(() => console.log({ asset: this.asset }), 500)
    // this.subProp(this.store.select(manageAssetReadonlyReselector), 'readOnly')
  }

  emailGenerator(publishCode: string) {
    const firstDate = this.event.first_date
    const dateText = firstDate ? `, ${compactDate(str2Date(firstDate))}` : ''
    const title = this.event.title || 'untitled event'
    const subject = `Information required for ${title}${dateText}`
    const body = `Hi there,\n\nBelow is a link to an asset form. Can you please complete the details and submit.\n\n${publishCode}\n\nThanks`
    return generateEmailLink(subject, body)
  }
  

  async setIcon() {
    const rect = document.getElementById('iconButton').getBoundingClientRect()
    const data: IconDialogData = { selectedIconId: this.asset.icon, rect, iconChoices: assetIconList, nameMap: assetIconToName }
    await openDialogGetResult(this.dialog, IconDialogComponent, { width: '300px', autoFocus: false, backdropClass: 'clear', data })
    if ((!data.selectedIconId && !this.asset.icon ) || data.selectedIconId === this.asset.icon) return
    this.asset.icon = data.selectedIconId
    this.saveAsset()
  }

  
  updateQuantity() {
    this.asset.quantity = getNumberFromText(this.asset.quantity, 0)
    this.saveAsset()
  }


  async manageInformableItem(item: InformableSectionItem, type: InformableType = 'event', holderName = 'event information') {
    const prunedItem = jsonCopyObject(item)
    delete prunedItem.informable
    delete prunedItem.section
    delete prunedItem.assetItemTitle
    const data:InformableEditInfo = { item: prunedItem, sectionId: item.section.id, information: item.informable.info, informableId: item.informable.id, informableType: type, informableKey: null, fromAsset: true }
    console.log(data)
    data.assetEntityHolderName = holderName

    this.changeDetectorRef.detach()
    await openDialogGetResult(this.dialog, InformableDialogComponent, {
      width: '480px',
      disableClose: true,
      data
    })
    this.changeDetectorRef.reattach()
  }

  async manageExhibitorStand(exhibitorStand: ExhibitorStand) {
    const data: ManageExhibitorStandData = { exhibitorStandId: exhibitorStand.id, nested: true }
    this.changeDetectorRef.detach()
    await openDialogGetResult(this.dialog, ManageExhibitorStandDialogComponent, { autoFocus: false, disableClose: true, data, panelClass: 'full-screen-modal' })
    this.changeDetectorRef.reattach()
  }


  async manageSession(sessionId: string, openTab: keyof SessionTabs = 'info') {
    const data: ManageSessionData = { sessionId, openTab }
    this.changeDetectorRef.detach()
    await openDialogGetResult(this.dialog, ManageSessionComponent, { autoFocus: false, disableClose: true, data, panelClass: 'full-screen-modal' })
    this.changeDetectorRef.reattach()
  }

  async manageActivity(data: ManageActivityData) {
    this.changeDetectorRef.detach()
    await openDialogGetResult(this.dialog, ManageActivityComponent, { autoFocus: false, disableClose: true, data, panelClass: 'full-screen-modal' })
    this.changeDetectorRef.reattach()
  }

  async manageProgram(programId: string, openTab: keyof ProgramTabs = 'basics') {
    const data: ManageProgramData = { programId, openTab }
    this.changeDetectorRef.detach()
    await openDialogGetResult(this.dialog, ManageProgramComponent, { autoFocus: false, disableClose: true, data, panelClass: 'full-screen-modal' })
    this.changeDetectorRef.reattach()
  }

  public labelUpdateFunction({ labels, labelTemplate, labelsToggled, labelsChanged }: LabelUpdateFunctionParams) {
    if (labelsToggled) {
      this.asset.labels = labels
      this.saveAsset()
    }
    if (labelsChanged ) {
      this.eventService.updateEvent(this.eventService.eventId, { asset_labels: labelTemplate })
    }
  }

  async clip() {
    switch(this.clipLabel) {
      case '+ ADD TO CLIPBOARD':
        this.clipLabel = 'SAVING...'
        await this.assetService.templateAssets([this.asset])
        this.clipLabel = 'ADDED'
        break
      default:
        break // nothing to do
    }
  }


  changeTab(tab) {
    this.selectedTab = tab
  }

  exit() {
    this.dialogRef.close()
  }

  saveAsset() {
    this.assetService.upsertAsset(this.asset)
  }

  toggleReady() {
    this.asset.ready = !this.asset.ready
    this.saveAsset()
  }

  toggleFlagged() {
    this.asset.flagged = !this.asset.flagged
    this.saveAsset()
  }

  toggleShowInBudget() {
    this.asset.showInBudget = !this.asset.showInBudget
    this.saveAsset()
  }

  updateAssetName(name: string) {
    this.asset.name = name
    this.saveAsset()
  }

  submitToggle(toggled: boolean) {
    this.asset.status = toggled ? 'Active' : 'Off'
    this.saveAsset()
  }

  changeStatus(status: StatusType) {
    this.asset.status = status as ItemStatus
    this.saveAsset()
  }

  async deleteAsset() {
    this.dialogRef.close()
    this.assetService.deleteAssets([this.asset.id])
  }

  setDueDate(date) {
    this.asset.dueDate = new Date(date).setHours(0, 0, 0, 0)
    this.saveAsset()
  }

  async removeDueDate(event) {
    const rect = event.target.getBoundingClientRect();
    const data: ConfirmDeleteData = {
      rect,
      title: 'Delete due date',
      dialog: this.dialog
    }
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return
    this.asset.dueDate = null
    this.saveAsset()
  }



  async setResponsibleWorker() {
    const selected = { people: {} }
    const rect = document.getElementById('responsibilityButton').getBoundingClientRect()
    const previousResponsibleParty = this.asset.responsibility
    if (previousResponsibleParty) selected.people[previousResponsibleParty] = true
    const data: PeoplePickerData = {
      x: rect.left,
      y: rect.top + 39,
      people: this.workforce,
      groups: null,
      multi: false,
      selected: selected,
      singleSelection: true,
      allGroupName: OMEGA_GROUP_NAME,
      title: 'Responsibility',
    }

    const response = await openDialogGetResult<{ selected: string }>(this.dialog, PeoplePickerComponent, { width: '300px', autoFocus: false, backdropClass: 'clear', data })

    if (!response || !response.selected) return
    const result = response.selected

    const responsibleEmail = !previousResponsibleParty || result !== previousResponsibleParty ? result : null
    this.asset.responsibility = responsibleEmail
    this.saveAsset()
  }

  async associateAsset() {
    const rect = document.getElementById('entityButton').getBoundingClientRect()
    const data: AllEntitySelectData = { selectedId: this.asset.associatedId, rect, includeResources: true }
    await openDialogGetResult(this.dialog, AllEntitySelectDialogComponent, { width: '300px', autoFocus: false, backdropClass: 'clear', data })
    if ((!data.selectedId && !this.asset.associatedId ) || data.selectedId === this.asset.associatedId) return
    this.asset.associatedId = data.selectedId
    this.saveAsset()
  }

  async getSubmitter() {
    const rect = document.getElementById('submitterDiv').getBoundingClientRect()
    const data: AllEntitySelectData = { selectedId: this.asset.submitterId, rect, includeResources: true }
    await openDialogGetResult(this.dialog, AllEntitySelectDialogComponent, { width: '300px', autoFocus: false, backdropClass: 'clear', data })
    if ((!data.selectedId && !this.asset.submitterId ) || data.selectedId === this.asset.submitterId) return
    
    this.asset.submitterId = data.selectedId
    this.asset.submitterType = data.selectedType
    this.saveAsset()
  }



}

export interface ManageAssetData {
  assetId: string
  nested?: boolean
}
